export const SMS = 'sms';
export const CALL = 'call';
export const EMAIL = 'email';
export const TOTP = 'totp';
